import { makeAutoObservable } from 'mobx'

class CommonStore {
  constructor() {
    makeAutoObservable(this)
  }
  /** Page name management */
  pageName = []
  setPage = pageName => {
    this.pageName = pageName
  }

  /** App theme */
  appTheme = {
    name: 'blue',
    solidColor: '#1890FF',
    solidLightColor: '#1890FF',
    gradientColor: '#1890FF',
  }

  /** Clear data */
  clearStore = () => {
    this.pageName.length = 0
    this.isSidebarCollapsed = false
    this.mouseCordinate = { x: 0, y: 0 }
  }
}

export default new CommonStore()
